import Icon from '../components/Icon.vue'

Icon.register({"weight-hanging":{"width":512,"height":512,"paths":[{"d":"M510.3 445.9L437.3 153.7C433.4 138.5 420.8 128 406.4 128H346.1C349.7 118 352 107.3 352 96 352 43 309 0 256 0S160 43 160 96C160 107.3 162.3 118 165.9 128H105.6C91.2 128 78.6 138.6 74.8 153.7L1.7 445.9C-6.6 479.2 16.4 512 48 512H464C495.6 512 518.6 479.2 510.3 445.9zM256 128C238.4 128 224 113.6 224 96S238.4 64 256 64 288 78.4 288 96 273.6 128 256 128z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/weight-hanging.js
// module id = null
// module chunks = 